<template>
  <DataTable stripedRows :value="filteredList" :paginator="showPagination"
    class="primevue-dtable tablepaginator p-datatable-customers rwd-table" :rows="10" dataKey="Id" :rowHover="true"
    v-model:selection="selectedCustomers" v-model:filters="filters" v-model:expandedRows="expandedRows"
    filterDisplay="menu" :loading="loading" sortable
    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
    :rowsPerPageOptions="computedRowsPerPageOptions"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    :globalFilterFields="globalFilterFields" responsiveLayout="scroll" @row-expand="onRowExpand"
    @row-collapse="onRowCollapse" @update:selection="selectAllHandler" @row-click="RowClick"
    @row-unselect-all="RowUnSelectAll" @row-unselect="RowUnSelect">
    <template #header>
      <b-row align-v="center">
        <b-col sm="7" xs="12">
          <slot name="QuoteComparison"></slot>
          <slot name="CustomDropdown"></slot>
          <slot name="CustomSearchBox"></slot>
          <slot name="statusFilterBtn" v-if="statusFilterBtn"> </slot>
        </b-col>
        <b-col sm="12" xs="12" class="d-flex justify-content-end align-items-center">
          <slot name="dropdownfilter"></slot>
          <slot name="tablefilter" v-if="sidefilter"></slot>
          <h5 class="m-0">{{ title }}</h5>

          <slot name="Addcustom" v-if="addnewbtn"></slot>


          <span class="p-input-icon-left my-3" v-if="searchbox">
            <i class="pi pi-search" />
            <InputText v-model="filters['global'].value" @input="filterGlobal" :placeholder="placeholder" />
          </span>

          <span class="p-input-icon-left table-search w-35 my-1" v-if="searchbox1">
            <i class="pi pi-search" />
            <InputText v-model="SearchValue.inputValue" @keyup="$emit('search', SearchValue.inputValue)"
              :placeholder="placeholder" />
          </span>

          <slot name="exceldownload" v-if="exceldownload"></slot>
          <slot name="filter" v-if="filterbtn"></slot>
          <slot name="Add"></slot>
        </b-col>
      </b-row>
    </template>

    <template #empty> No {{ title }} found. </template>
    <template #loading> Loading {{ title }} data. Please wait. </template>

    <template>
      <Column expander style="width: 5rem" v-if="expandSubRows" class="field" />
      <Column header="#" headerStyle="width:3rem" v-if="serialNumber">
        <template #body="slotProps">
          {{ calculateSerialNumber(slotProps.index) }}
        </template>
      </Column>
      <!-- <Column selectionMode="multiple" v-if="computedSelectionMode" class="normalcolumnfreezeleft1"></Column> -->
      <Column selectionMode="multiple" v-if="computedSelectionMode" class=""></Column>

      <Column v-for="col in columns" :key="col.field" :field="col.field" :filterField="col.field" :header="col.header"
        :sortable="col.sortable" :slot="col.slot" :data-type="col.dataType"
        :showFilterMatchModes="showColumnFilters && col.ShowMactchMode" :body-class="col.bodyclass" :hidden="col.hide"
        :class="[col.class, col.frozencolumn ? 'columnfreeze' : '']" :selectionMode="col.selectionMode">

        <template #header>
          <div v-if='col.checkfield == true' class="flex flex-wrap align-items-center justify-content-between gap-2">
            <slot :name="col.header"></slot>
          </div>
        </template>
        <template #body="{ data }" v-if="col.dataType != 'date'">
          <span v-if="col.fieldDisplay != 'false'" :data-header="col.header" class="body-data"
            :title="data[col.field]">{{
              data[col.field]
            }}</span>
          <span v-else :data-header="col.header" class="body-data">
            <slot :name="col.slot" :data="data" :header="col.header"></slot>
          </span>
        </template>
        <template #body="{ data }" v-if="col.dataType === 'date'">
          {{ formatDate(new Date(data[col.field])) }}
        </template>
        <template #filter="{ filterModel, field }" v-if="showColumnFilters">
          <template v-if="col.filterTemplate == 'Search'">
            <InputText type="text" v-model="filterModel.value" class="p-column-filter"
              :placeholder="`Search by ${col.field}`" />
          </template>
          <template v-if="col.filterTemplate == 'MultiSelect'">
            <MultiSelect v-model="filterModel.value" :options="[
              ...new Set(
                filters[field].options.map((option) => option[col.field])
              ),
            ]" placeholder="Any" class="p-column-filter">
              <template #option="slotProps">
                <div class="p-multiselect-representative-option">
                  <span class="image-text">{{ slotProps.option }}</span>
                </div>
              </template>
            </MultiSelect>
          </template>
          <template v-if="col.filterTemplate == 'DateFilter'">
            <Calendar v-model="filterModel.value" @date-select="formatDate(filterModel.value)"
              placeholder="mm/dd/yyyy" />
          </template>
        </template>
      </Column>
    </template>
    <template #expansion="slotProps">
      <DataTable :value="getSubtableData(SubList)" responsiveLayout="scroll" class="py-4">
        <Column v-for="subCol in subColumns" :key="subCol.field" :field="subCol.field" :header="subCol.header" />
      </DataTable>
    </template>

    <template #footer v-if="!showPagination">
      <b-row>
        <div class="my-2 transactionpaginator">
          <div>
            <b-pagination v-model="state.currentPage" :total-rows="totalRecords" :per-page="state.pageSize"
              class="paginator-right"></b-pagination>
          </div>
          <div class="px-4 pagination-text my-5 my-sm-0 my-md-0 my-lg-0">
            Showing {{ (state1.currentPage - 1) * state1.pageSize + 1 }} to
            {{ Math.min(state1.currentPage * state1.pageSize, totalRecords) }}
            of {{ totalRecords }} entries
          </div>
          <div class="field pagination-dropdown">
            <Dropdown v-model="state1.pageSize" :options="computedRowsPerPageOptions" @change="ShowRowsOnChange" />
          </div>
        </div>
      </b-row>
    </template>
  </DataTable>
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  PropType,
  reactive,
  computed,
  watch,
  onMounted,
} from "vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import clearbtn from "../GeneralButtons/ClearButton.vue";
import CustomDropDown from "./Dropdown.vue";
import Datepicker from "./DatePicker.vue";
import { debounce } from "lodash";
import { Trie } from "../../helper/search";


interface ColumnConfig {
  field: string;
  header: string;
  sortable: boolean;
  slot?: string;
  dataType?: string;
  showFilterMatchModes?: boolean;
  bodyclass?: string;
  hide?: boolean;
  class?: string;
  frozencolumn?: boolean;
  checkfield?: boolean;
  filterTemplate?: string;
  fieldDisplay?: string;
}

export default defineComponent({
  components: {
    clearbtn,
    CustomDropDown,
    Datepicker,
  },

  props: {
    expandSubRows: {
      type: Boolean,
      default: false,
    },
    searchbox: {
      type: Boolean,
      default: true,
    },
    sidefilter: {
      type: Boolean,
      default: false,
    },
    searchbox1: {
      type: Boolean,
      default: false,
    },
    exceldownload: {
      type: Boolean,
      default: false,
    },
    filterbtn: {
      type: Boolean,
      default: false,
    },
    filters: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      default: "",
    },
    columns: {
      type: Array as PropType<any[]>,
      required: true,
    },
    List: {
      type: Array as () => ColumnConfig[],
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    paginator: {
      type: Boolean,
      default: false,
    },
    onEdit: {
      type: Function,
    },
    totalRecords: {
      type: Number,
      default: 0,
    },
    state: {
      type: Object,
      default: {},
    },
    placeholder: {
      type: String,
      default: "Search",
    },
    tableorganizationdd: {
      type: Boolean,
      default: false,
    },
    ExportButton: {
      type: Boolean,
      default: true,
    },
    serialNumber: {
      type: Boolean,
      default: false,
    },
    statusFilterBtn: {
      type: Boolean,
      default: false,
    },
    SubList: {
      type: Array,
      default: () => [],
    },
    subColumns: {
      type: Array as PropType<any[]>,
      required: false,
    },
    showColumnFilters: {
      type: Boolean,
      default: true,
    },
    selection: {
      type: Array,
    },
    selectionMode: {
      type: [Boolean, String],
      default: false,
    },
    addnewbtn: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, { emit }) {
    const computedRowsPerPageOptions = computed(() => {
      const defaultOptions = [10, 25, 50, 100];
      // return [...defaultOptions, props.List.length];
      return [...defaultOptions];
    });

    // const showPagination = computed(() => props.paginator && props.List.length > 25);
    const showPagination = props.paginator;

    const searchQuery = ref('');
    const filteredList = ref<any[]>([]);
    const trie = new Trie();
    const expandedRows = ref({});

    // Insert all items into Trie
    props.List.forEach((item: any) => {
      trie.insert(item.name);
    });

    // Debounced and memoized function to filter data
    const filterGlobal = debounce(() => {
      if (searchQuery.value) {
        const matchedItems: any = memoizedSearch(searchQuery.value);
        filteredList.value = props.List.filter((item: any) => matchedItems.includes(item.name));
      } else {
        filteredList.value = [...props.List];
      }
    }, 100);

    // Memoization function
    const memoizedSearch = (value: string) => {
      if (!memoizedSearch.cache.has(value)) {
        memoizedSearch.cache.set(value, trie.searchPrefix(value));
      }
      return memoizedSearch.cache.get(value);
    };
    memoizedSearch.cache = new Map<string, string[]>();

    const state1 = reactive({
      currentPage: 1,
      // pageSize: 25,
      pageSize: 10,
      totalRows: 0,
      rowsCount: 0,
    });

    let totalPages = Math.ceil(props.totalRecords / state1.pageSize);

    watch(props, (newValue) => {
      Object.assign(state1, newValue.state);
      totalPages = Math.ceil(props.totalRecords / state1.pageSize);
    });

    onMounted(() => {
      Object.assign(state1, props.state);
      totalPages = Math.ceil(props.totalRecords / state1.pageSize);
    });

    const selectedCustomers = ref([]);
    const loading = ref(false);
    const filters = ref(props.filters);
    const globalFilterFields = ref([]);
    const clearFilter1 = () => { };

    const EditData = (data) => {
      emit("edit-data", data);
    };

    const DeleteData = (data) => {
      emit("delete-data", data);
    };

    const AddNew = () => {
      emit("add-new");
    };

    const formatDate = (value) => {
      return value.toLocaleDateString("en-US", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    };

    function ShowRowsOnChange() {
      emit("ShowRows", state1.pageSize);
    }

    let SearchValue = ref({
      inputValue: "",
      fromdate: "",
      todate: "",
    });

    // const onRowExpand = (event: any) => {
    //   expandedRows.value = [event.data];
    //   emit("expandRows", event.data);
    // };

    const onRowExpand = (event: any) => {
      // Reset object and set only the current row as expanded
      expandedRows.value = {
        [event.data.Id]: true,
      };
      emit("expandRows", event.data);
    };


    const getSubtableData = (parentData: any) => {
      return parentData || [];
    };


    const onRowCollapse = (event: any) => {
      delete expandedRows.value[event.data.Id];
      emit("collapseRows", event.data);
    };


    function calculateSerialNumber(index: number) {
      return ((state1.currentPage - 1) * state1.pageSize) + (index + 1);
    }
    // Handle both boolean and string values for selectionMode
    const computedSelectionMode = computed(() => {
      // Only show checkbox column when selectionMode is explicitly true (boolean)
      return props.selectionMode === true;
    });

    watch(
      () => props.selection,
      (newVal: any) => {
        selectedCustomers.value = newVal;
        update()
      }
    );

    function update() {
      emit("selection", selectedCustomers.value);
    }

    function selectAllHandler(event) {
      selectedCustomers.value = event;
      update();
    }

    function RowClick(event) {
      emit("row-click", event);
    }

    function RowUnSelectAll(event) {
      emit("row-unselect-all", event);
    }

    function RowUnSelect(event) {
      emit("row-unselect", event);
    }

    return {
      searchQuery,
      filteredList,
      filterGlobal,
      clearFilter1,
      filters,
      selectedCustomers,
      loading,
      globalFilterFields,
      EditData,
      DeleteData,
      AddNew,
      formatDate,
      state1,
      totalPages,
      ShowRowsOnChange,
      SearchValue,
      onRowExpand,
      onRowCollapse,
      expandedRows,
      calculateSerialNumber,
      computedRowsPerPageOptions,
      showPagination,
      selectAllHandler,
      RowClick,
      RowUnSelectAll,
      RowUnSelect,
      computedSelectionMode,
      getSubtableData
    };
  },
});
</script>

<style lang="scss">
@import "../../assets/variables.scss";

.addbtn {
  background-color: $AddButton !important;
  border: none !important;
}

.add .p-button {
  padding: 0.5rem 0.55rem !important;
  font-size: 12px;
  white-space: nowrap;
}

.add-new {
  background: #0a82ff;
  border: #0a82ff;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  color: #ffffff;
}

.add-new:hover {
  background: #0a82ff !important;
  --n-text-color-hover: #ffffff !important;
  --n-border-hover: 1px solid #0a82ff !important;
}

.add-new:focus {
  background: #0a82ff !important;
  --n-text-color-focus: #ffffff !important;
  --n-border-focus: 1px solid #0a82ff !important;
}

.clear-button {
  background: #e1e1e1;
  border: #e1e1e1;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  color: #000000;
}

.clear-button:hover {
  background: #e1e1e1 !important;
  --n-text-color-hover: #000000 !important;
  --n-border-hover: 1px solid #e1e1e1 !important;
}

.clear-button:focus {
  background: #e1e1e1 !important;
  --n-text-color-focus: #000000 !important;
  --n-border-focus: 1px solid #e1e1e1 !important;
}

.primevue-dtable .float-rights {
  float: right;
}

.p-datatable-wrapper {
  padding-inline: 15px;
}

.createbilltable .p-datatable-wrapper {
  padding-inline: 0px;
}

.p-datatable .p-datatable-tbody>tr>td {
  padding: 0px 5px !important;
  margin: 5px;
  height: 40px;
  vertical-align: middle;
  color: $PTBodyColor;
  font-size: 12px;
  line-height: 18px;
  // white-space: nowrap;
  border-left: 1px solid #e1e1e1 !important;
}

.p-datatable .p-datatable-header {
  // background: $PTOverallHeaderBg !important;
  background: #ffffff !important;
  padding: 0rem 0.5rem !important;
}

.p-datatable .p-datatable-thead>tr>th {
  padding: 5px 10px !important;
  background: $PTHeader-Bg !important;
  font-weight: 500 !important;
  font-size: 15px;
  color: $PTHeaderColor !important;
  text-transform: capitalize;
}

// .p-datatable.p-datatable-gridlines .p-datatable-tbody>tr>td:first-child {
//   text-align: center;
// }

.p-datatable.p-datatable-hoverable-rows .p-datatable-tbody>tr:not(.p-highlight):hover {
  border: 1px solid $PTBodyHoverBorder !important;
  background: $PTBodyHoverBg !important;
}

.p-datatable .p-datatable-tbody>tr:focus {
  outline: none !important;
}

.p-datatable-responsive-scroll>.p-datatable-wrapper::-webkit-scrollbar {
  height: 9px !important;
}

.p-datatable .p-column-title {
  white-space: nowrap;
}

.p-button.p-button-icon-only.p-button-rounded {
  border-radius: 9% !important;
  height: 1rem !important;
  margin: 2% 4%;
}

.p-paginator .p-paginator-pages .p-paginator-page {
  min-width: 2rem !important;
  height: 2rem !important;
}

.p-paginator .p-paginator-first,
.p-paginator .p-paginator-prev,
.p-paginator .p-paginator-next,
.p-paginator .p-paginator-last {
  min-width: 2rem !important;
  height: 2rem !important;
}

td .pi {
  font-size: 14px !important;
}

.p-button.p-button-icon-only {
  padding: 10px 10px !important;
}

.p-button.p-button-icon-only {
  width: 1rem !important;
}

.p-paginator {
  // background: $PPaginatorBg !important;
  background: #ffffff !important;
  border: solid $PPaginatorBorder !important;
  border-width: 1px !important;
  border-radius: 0px !important;
}

.p-paginator-bottom {
  display: flex;
  justify-content: center;
  background: #ffffff;
  // background: $PTOverallHeaderBg !important;
}

.table-search .p-inputtext {
  padding: 0.45rem 0.55rem 0.45rem 2rem !important;
  width: 100%;
}

// .table-search .p-inputtext:enabled:hover {
//   border-color: #e1e1e1;
//   width: 100%;
// }

.table-search .p-inputtext:enabled:focus {
  box-shadow: 3px 3px #e1e1e1 !important;
  border-color: #e1e1e1;
  width: 100%;
}

.p-datatable .p-column-header-content {
  text-transform: capitalize;
}

.p-datatable-wrapper {
  // background-color: $PTWrapperBg;
  background-color: #ffffff;
}

//Table-Column-Class
.boldclass {
  font-weight: 500 !important;
  color: #000000 !important;
  text-transform: capitalize !important;
}

.red_td {
  color: #E12A02;
}

.blue_td {
  color: #4D96FF !important;
  cursor: pointer;
}

.right-td {
  text-align: right !important;
}

.width150 {
  min-width: 150px;
}

.width200 {
  min-width: 200px;
}

.width250 {
  min-width: 250px;
}

.width100 {
  min-width: 100px;
}

.width550 {
  min-width: 50%;
}

.width60 {
  min-width: 60px;
}

.minWidth input {
  width: 60px !important;
}

.medwidth input {
  width: 100px !important;
}

.smallwidth {
  min-width: 90px;
}

.mediumsmallwidth {
  min-width: 120px;
}

.mediumwidth {
  min-width: 180px;
}

.largewidth span {
  min-width: 270px;
}

.exlargewidth {
  min-width: 360px;
}

.p-column-filter-menu {
  display: inline-flex;
  margin-left: auto;
  float: right;
}

.text_overflow1 span {
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: wrap !important;
  /* cursor: pointer; */
}

.text_overflow2 span {
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: wrap !important;
  /* cursor: pointer; */
}

//Table-Filter
.p-column-filter-menu-button:focus {
  box-shadow: none !important;
}

.p-column-filter-menu-button:hover {
  background: none !important;
}

.p-column-filter-menu {
  padding-left: 5%;
  padding-right: 5%;
}

th svg {
  color: #f9fbfc;
  height: 14px;
  width: 14px;
  cursor: pointer;
}

th:hover svg {
  color: #444444;
  height: 14px;
  width: 14px;
  cursor: pointer;
}

th svg:focus {
  color: #444444 !important;
  height: 14px;
  width: 14px;
  cursor: pointer;
}

.p-column-filter-menu-button.p-column-filter-menu-button-active,
.p-column-filter-menu-button.p-column-filter-menu-button-active:hover {
  background: #bababa !important;
  color: #4338ca;
}

.p-column-filter-menu-button {
  width: 1.5rem;
  height: 1.5rem;
}

.p-column-filter-menu-button svg {
  font-size: 12px;
}

.filterdisplaynone .p-column-filter-menu-button {
  display: none !important;
}

//Table-Filter

//Table-Column-Class

//Table_Border
.p-datatable.p-datatable-gridlines .p-datatable-header {
  border-width: 0px 0px 0px 0px !important;
}

// .p-datatable.p-datatable-gridlines .p-datatable-tbody>tr>td {
//   border-width: 0px !important;
// }

.p-datatable .p-datatable-footer {
  // background: $PTOverallHeaderBg !important;
  background: #ffffff !important;
  border: none !important;
}

.p-datatable .p-datatable-footer .pagination-text {
  margin: 0px !important;
}

.p-paginator {
  border-width: 0px !important;
}

.p-datatable .p-datatable-tbody>tr {
  border: 1px solid $PTBodyBorder;
}

.p-datatable .p-datatable-thead>tr>th {
  border: 1px solid $PTHeadBorder !important;
}

//Table_Border

.table-width-80 .p-datatable-table {
  min-width: 80% !important;
}

.table-width-80 .p-datatable-footer {
  width: 100% !important;
}

.table-width-80 .p-paginator {
  width: 80% !important;
}

@media only screen and (max-width: 1024px) {
  .table-width-80.p-datatable-table {
    min-width: 100%;
  }

  .table-width-80 .p-datatable-footer {
    width: 100% !important;
  }

  .table-width-80 .p-paginator {
    width: 100% !important;
  }
}

.pagination-text {
  color: #999999;
  font-size: 14px;
  font-weight: 400;
}

.pagination-dropdown {
  margin-bottom: 0px !important;
}

.pagination-dropdown .p-inputtext {
  padding: 0.5rem 0.1rem 0.5rem 0.5rem !important;
  color: #999999;
  font-size: 14px;
  font-weight: 400;
}

.pagination-dropdown .p-dropdown .p-dropdown-trigger {
  width: 2rem;
}

.p-paginator .p-dropdown .p-dropdown-trigger {
  width: 1rem;
  padding-right: 15px;
}

.pagination-dropdown .pi {
  color: #999999;
  font-size: 14px;
  font-weight: 400;
}

.tablepaginator .p-paginator .p-inputtext {
  padding: 7px !important;
}

.tablepaginator .p-paginator .p-dropdown {
  // margin-left: 0.5rem;
  // margin-right: 0.5rem;
  height: 2rem;
  width: 57px;
}

.transactionpaginator {
  display: flex;
  align-items: center;
  justify-content: center;
}

// .p-datatable.p-datatable-gridlines .p-datatable-thead > tr > th {
//     min-width: 150px;
// }
// .p-datatable.p-datatable-gridlines .p-datatable-tbody > tr > td {
//   min-width: 150px;
// }
@media only screen and (max-width: 450px) {

  .p-paginator .p-paginator-first,
  .p-paginator .p-paginator-prev,
  .p-paginator .p-paginator-next,
  .p-paginator .p-paginator-last,
  .p-paginator .p-paginator-pages .p-paginator-page {
    min-width: 1rem !important;
    height: 1rem !important;
  }

  .p-paginator .p-paginator-current {
    min-width: 1rem;
    height: 1rem;
    font-size: 12px;
  }

  .tablepaginator .p-paginator .p-dropdown {
    height: 25px;
    width: 35px;
  }

  .tablepaginator .p-paginator .p-inputtext {
    padding: 5px 2px;
    font-size: 12px;
  }

  .p-paginator .p-paginator-pages .p-paginator-page {
    font-size: 12px;
  }

  .p-paginator .p-dropdown .p-dropdown-trigger {
    width: 0.5rem;
    padding-right: 8px;
  }

  .p-paginator .pi {
    font-size: 10px;
  }
}

.p-datatable .p-datatable-tbody>tr>td .p-row-toggler:focus {
  box-shadow: none !important;
  color: #343a40;
  border-color: transparent;
  background: #e9ecef;
}
</style>

<style>
@media only screen and (max-width: 545px) {

  .p-datatable-table,
  .p-selectable-row {
    margin: 5px auto;
  }

  .p-datatable thead,
  .mob-header {
    display: none;
  }

  .p-datatable,
  .p-datatable tbody,
  .p-datatable tr,
  .p-datatable td,
  .p-datatable th {
    display: block;
  }

  .p-datatable td .body-data::before {
    content: attr(data-header) " : ";
    width: 150px;
    min-height: 34px;
    height: auto;
    float: left;
    font-weight: bold;
    color: #000000;
    text-transform: uppercase;
    padding-top: 1%;
    font-size: 12px;
    overflow-wrap: break-word;
  }

  .body-data {
    /* vertical-align: -webkit-baseline-middle; */
    overflow-wrap: break-word;
    line-height: 18px;
  }

  .p-datatable td span[data-header=""]::before {
    display: none;
  }

  .last-column-position {
    /* Reset positioning for Empty data-header */
    position: absolute;
    /* top: 5px; */
    top: 0px;
    right: 5px;
  }

  tr {
    position: relative;
  }

  .p-datatable .p-datatable-tbody>tr>td {
    min-height: 34px;
    height: auto;
  }

  .table-width-80 .p-datatable-table {
    min-width: 100% !important;
  }

  .table-width-80 .p-datatable-footer {
    width: 100% !important;
  }

  .table-width-80 .p-paginator {
    width: 100% !important;
  }

  .transactionpaginator {
    flex-wrap: wrap;
    text-align: center;
  }

  .transactionpaginator .pagination {
    justify-content: center !important;
  }

  .pagination-dropdown .p-dropdown {
    height: 25px !important;
    width: 50px !important;
  }

  .pagination-dropdown .p-dropdown .p-inputtext {
    padding: 5px !important;
  }

  .pagination-dropdown .p-dropdown .p-dropdown-trigger {
    width: 1.35rem;
  }
}

@media only screen and(max-width:450px) {
  .p-datatable td .body-data::before {
    width: 100px;
  }
}

.exportadd {
  height: 30px;
}

.tablefilter {
  color: #6366f1;
  background-color: #e1e1e1;
  padding: 10px !important;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
}

.editicon .pi-ellipsis-v {
  color: #000000;
  background-color: #f7f7f7;
  padding: 20px 0px;
}

.body-data .editicon {
  padding: 15px 10px !important;
}

td .p-badge-success,
td .p-badge-warning {
  padding-inline: 15px !important;
  border-radius: 15px;
}

.right-td {
  text-align: right !important;
  /* color: #444444; */
  /* margin-right: 20px; */
}

.center-td {
  text-align: center !important;
}

#overlay_menu .p-submenu-header {
  display: none;
}

/* Header Last Column Border */
.p-datatable .p-datatable-thead>tr>th:nth-last-child(2) {
  border-right: 0px solid #e1e1e1 !important;
}

.p-datatable .p-datatable-thead>tr>th:last-child {
  border-left: 0px solid #e1e1e1 !important;
}

/* Header Last Column Border */

.text_overflow {
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.text_overflow span {
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.p-datatable-wrapper {
  max-height: 50vh;
  overflow: auto;
  scroll-behavior: smooth;
}

.p-datatable-thead {
  position: sticky;
  top: -1px;
  z-index: 10;
  /* Stick the header to the top */
}

.columnfreeze {
  position: sticky;
  right: -1px;
  z-index: 1;
  width: 40px !important;
  text-align-last: center;
  background-color: #e1e1e1;
}

/* .columnfreeze :nth-child(odd) {
  background-color: #FFFFFF;
}

.columnfreeze :nth-child(even) {
  background-color: #fcfcfc;
} */
</style>
